<template>
  <div class="contenedor-gral">
    <div class="contenedor-circulos" id="contenedor-circulos">
      <div
        id="tooltip-nodo"
        :class="[
          ancho_pantalla < 769 ? 'tooltip-nodo-movil' : 'tooltip-nodo-full',
        ]"
      >
        <p class="info_tooltip">
          Nombre: <span class="highlight">{{ nombre_tooltip }} </span>
        </p>
        <p class="info_tooltip" v-if="alias_tooltip != null">
          Alias: <span class="highlight">{{ alias_tooltip }} </span>
        </p>
        <p
          class="info_tooltip"
          v-if="nombre_tooltip != 'Ismael Zambada García'"
        >
          Relación:
          <span class="highlight">{{ vinculo_tooltip }} </span>
        </p>
        <p class="info_tooltip">
          Fecha en que entró: <span class="highlight">{{ anio_tooltip }} </span>
        </p>
        <p class="info_tooltip">
          Permanece: <span class="highlight">{{ permanece_tooltip }} </span>
        </p>
      </div>
      <svg
        class="circulos-concentricos"
        id="circulos-concentricos"
        :width="ancho + margenes.derecha + margenes.izquierda"
        :height="alto_svg"
      >
        <g
          class="grupo-circulos"
          :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
        ></g>
        <g
          class="grupo-fotos"
          :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
        ></g>
      </svg>
    </div>

    <div class="contenedor-tabla">
      <h1>{{ nodo_seleccionado }}</h1>
      <p v-if="personas_morales.length == 0 && personas_fisicas.length == 0">
        No hay empresas vinculadas
      </p>

      <div class="personas_morales" v-if="personas_morales.length > 0">
        <h3>Empresas relacionadas</h3>
        <table>
          <tr>
            <th>Nombre</th>
            <th>Fecha de ingreso</th>
            <th>Permanence</th>
          </tr>
          <tr v-for="(empresa, index) in personas_morales" :key="index">
            <td>{{ empresa.nombre }}</td>
            <td>{{ empresa["fecha_formateada"] }}</td>
            <td>{{ empresa["Permanece"] }}</td>
          </tr>
        </table>
      </div>

      <div class="personas_fisicas" v-if="personas_fisicas.length > 0">
        <h3>Personas relacionadas</h3>
        <table>
          <tr>
            <th>Nombre</th>
            <th>Fecha de ingreso</th>
            <th>Permanencia</th>
          </tr>
          <tr v-for="(empresa, index) in personas_fisicas" :key="index">
            <td>{{ empresa.nombre }}</td>
            <td>{{ empresa["fecha_formateada"] }}</td>
            <td>{{ empresa["Permanece"] }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
import * as d3 from "d3";
import datos from "../assets/data/vinculos_mayo.json";
import data_nodos from "../assets/data/data_empresas.json";

const data = ref(datos);
const datum = ref(data_nodos);
const personas_morales = ref([]);
const personas_fisicas = ref([]);
const max_levels = ref({ 0: 1, 1: 12, 2: 12, 3: 16 });
const level_colors = ref({
  0: { Sí: "#BB340F", No: "#68A500" },
  1: { Sí: "#BB340F", No: "#68A500" },
  2: { Sí: "#BB340F", No: "#68A500" },
  3: { Sí: "#BB340F", No: "#68A500" },
});
const color_circs = ref("#BB340F");
const circulos = ref([]);

const contenedor_circulos = ref();
const svg = ref();
const grupo_circulos = ref();
const grupo_fotos = ref();
const alto = ref();
const alto_svg = ref(400);
const ancho = ref(0);
const margenes = ref({
  derecha: 20,
  izquierda: 20,
  abajo: 5,
  arriba: 5,
});

const centro_x = ref();
const centro_y = ref();
const radio_padding = ref();
const radio_centro = ref();
const radio_nodo = ref();

const tooltip_nodo = ref();
const nombre_tooltip = ref();
const alias_tooltip = ref();
const vinculo_tooltip = ref();
const anio_tooltip = ref();
const permanece_tooltip = ref();

const nodo_seleccionado = ref("Ismael Zambada García");
const ancho_pantalla = ref();

onMounted(() => {
  contenedor_circulos.value = document.getElementById(`contenedor-circulos`);
  svg.value = d3.select(`svg#circulos-concentricos`);
  grupo_circulos.value = svg.value.select("g.grupo-circulos");
  grupo_fotos.value = svg.value.select("g.grupo-fotos");
  tooltip_nodo.value = d3.select("div#tooltip-nodo");
  tooltip_nodo.value.style("visibility", "hidden");

  dimensionding();
  set_data();
  dibujanding();
  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});
watch(nodo_seleccionado, () => {
  dimensionding();
  set_data();
  dibujanding();
});

function set_data() {
  //console.log(data.value);
  personas_morales.value = [];
  //Ahora vamos a obtener la data para la tabla de personas morales
  datum.value.map((d) => {
    if (d["Tipo de persona"] == "Persona moral") {
      if (
        d["Vinculada a "] == nodo_seleccionado.value ||
        d["Unnamed: 5"] == nodo_seleccionado.value
      ) {
        personas_morales.value.push(d);
      }
    }
  });
  //console.log(personas_morales.value);
  personas_fisicas.value = [];
  //Ahora vamos a obtener la data para la tabla de personas morales
  datum.value.map((d) => {
    if (d["Tipo de persona"] == "Persona fisica") {
      if (
        d["Vinculada a "] == nodo_seleccionado.value ||
        d["Unnamed: 5"] == nodo_seleccionado.value
      ) {
        personas_fisicas.value.push(d);
      }
    }
  });
}
function reescalanding() {
  dimensionding();
  dibujanding();
}
function dimensionding() {
  ancho_pantalla.value = window.innerWidth;
  console.log("ancho: ", ancho_pantalla.value);
  ancho.value =
    contenedor_circulos.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;
  radio_padding.value = ancho.value / 8;
  radio_centro.value = ancho.value / 9.5;
  radio_nodo.value = (radio_padding.value - 5) / 3.5;
  alto_svg.value = radio_padding.value * 9;
  alto.value = alto_svg.value - margenes.value.arriba - margenes.value.abajo;

  centro_x.value = ancho.value / 2;
  centro_y.value = alto_svg.value / 2;

  // Esta parte de modificar la data se hace aquí porque estamos cambiando el radio al cambiar el tamaño de la pantalla
  data.value.map((d) => {
    // El radio debe ser n veces el padding establecido entre círculos. así
    d.radio = d.nivel * radio_padding.value;
    d.angulo = (d.sub_index * (2 * Math.PI)) / max_levels.value[d.nivel];
  });

  circulos.value = [
    {
      nivel: 3,
      radio: 3 * radio_padding.value + radio_centro.value,
      color: color_circs.value,
    },
    {
      nivel: 2,
      radio: 2 * radio_padding.value + radio_centro.value,
      color: color_circs.value,
    },
    {
      nivel: 1,
      radio: 1 * radio_padding.value + radio_centro.value,
      color: color_circs.value,
    },
  ];
}

function dibujanding() {
  // Agregamos los círculos generales
  grupo_circulos.value
    .selectAll("circle.gral")
    .data(circulos.value)
    .join(
      (enter) => {
        enter
          .append("circle")
          .attr("class", "gral")
          .attr("cx", ancho.value / 2)
          .attr("cy", alto.value / 2)
          .attr("r", (d) => d.radio)
          .attr("fill", "white")
          .attr("stroke", (d) => d.color)
          .attr("stroke-width", 3)
          .attr("opacity", (d) => {
            console.log(d.nombre);
            if (nodo_seleccionado.value == "Ismael Zambada García") {
              return 0.7;
            } else {
              return 0.2;
            }
          });
      },
      (update) => {
        update
          .transition()
          .attr("cx", ancho.value / 2)
          .attr("cy", alto.value / 2)
          .attr("r", (d) => d.radio)
          .attr("fill", "white")
          .attr("stroke", (d) => d.color)
          .attr("stroke-width", 3)
          .attr("opacity", (d) => {
            console.log(d.nombre);
            if (nodo_seleccionado.value == "Ismael Zambada García") {
              return 0.7;
            } else {
              return 0.2;
            }
          });
      },
      (exit) => {
        exit.remove();
      }
    );

  //Agregamos los círculos de cada nodo
  grupo_circulos.value
    .selectAll("circle.nodo")
    .data(data.value)
    .join(
      (enter) => {
        enter
          .append("circle")
          .attr("class", "nodo")
          .attr("cx", (d) => {
            if (d.nivel == 0) {
              return Math.sin(d.angulo) * d.radio + ancho.value / 2;
            } else {
              return (
                Math.sin(d.angulo) * (d.radio + radio_centro.value) +
                ancho.value / 2
              );
            }
          })
          .attr("cy", (d) => {
            if (d.nivel == 0) {
              return Math.cos(d.angulo) * d.radio + alto.value / 2;
            } else {
              return (
                Math.cos(d.angulo) * (d.radio + radio_centro.value) +
                alto.value / 2
              );
            }
          })
          .attr("r", (d) => {
            if (d.nivel == 0) {
              return radio_centro.value;
            } else {
              return radio_nodo.value;
            }
          })
          .attr("fill", (d) => level_colors.value[d.nivel][d.permanece_OFAC])
          .attr("opacity", 0.8)
          .attr("opacity", (d) => {
            if (nodo_seleccionado.value == "Ismael Zambada García") {
              return 1;
            } else {
              if (d.nombre == nodo_seleccionado.value) {
                return 1;
              } else {
                return 0.5;
              }
            }
          });
        /*           .attr("stroke", (d) => {
            if (d.nombre == nodo_seleccionado.value) {
              return color_seleccion.value;
            } else {
              return (d) => level_colors.value[d.nivel];
            }
          })
          .attr("stroke-width", 2); */
      },
      (update) => {
        update
          .transition()
          .attr("cx", (d) => {
            if (d.nivel == 0) {
              return Math.sin(d.angulo) * d.radio + ancho.value / 2;
            } else {
              return (
                Math.sin(d.angulo) * (d.radio + radio_centro.value) +
                ancho.value / 2
              );
            }
          })
          .attr("cy", (d) => {
            if (d.nivel == 0) {
              return Math.cos(d.angulo) * d.radio + alto.value / 2;
            } else {
              return (
                Math.cos(d.angulo) * (d.radio + radio_centro.value) +
                alto.value / 2
              );
            }
          })
          .attr("r", (d) => {
            if (d.nivel == 0) {
              return radio_centro.value;
            } else {
              return radio_nodo.value;
            }
          })
          .attr("fill", (d) => level_colors.value[d.nivel][d.permanece_OFAC])
          .attr("opacity", (d) => {
            if (nodo_seleccionado.value == "Ismael Zambada García") {
              return 1;
            } else {
              if (d.nombre == nodo_seleccionado.value) {
                return 1;
              } else {
                return 0.5;
              }
            }
          });
      },
      (exit) => {
        exit.remove();
      }
    );

  // Agregamos las fotos
  grupo_fotos.value
    .selectAll("image")
    .data(data.value)
    .join(
      (enter) => {
        enter
          .append("image")
          .attr("x", (d) => {
            if (d.nivel == 0) {
              return (
                Math.sin(d.angulo) * d.radio +
                ancho.value / 2 -
                radio_centro.value +
                4
              );
            } else {
              return (
                Math.sin(d.angulo) * (d.radio + radio_centro.value) +
                ancho.value / 2 -
                radio_nodo.value +
                4
              );
            }
          })
          .attr("y", (d) => {
            if (d.nivel == 0) {
              return (
                Math.cos(d.angulo) * d.radio +
                alto.value / 2 -
                radio_centro.value +
                4
              );
            } else {
              return (
                Math.cos(d.angulo) * (d.radio + radio_centro.value) +
                alto.value / 2 -
                radio_nodo.value +
                4
              );
            }
          })
          .attr("height", (d) => {
            if (d.nivel == 0) {
              return radio_centro.value * 2 - 8;
            } else {
              return radio_nodo.value * 2 - 8;
            }
          })
          .attr("width", (d) => {
            if (d.nivel == 0) {
              return radio_centro.value * 2 - 8;
            } else {
              return radio_nodo.value * 2 - 8;
            }
          })
          .attr("href", (d) => {
            let nuevo_nombre = d.nombre
              .toLowerCase()
              .replace("á", "a")
              .replace("é", "e")
              .replace("é", "e")
              .replace("í", "i")
              .replace("í", "i")
              .replace("ó", "o")
              .replace("ú", "u")
              .replace("ñ", "n");
            if (d.con_foto == "si") {
              return require(`../assets/img/${nuevo_nombre}.png`);
            } else {
              return require("../assets/img/sin foto.png");
            }
          })
          .attr("opacity", (d) => {
            if (nodo_seleccionado.value == "Ismael Zambada García") {
              return 1;
            } else {
              if (d.nombre == nodo_seleccionado.value) {
                return 1;
              } else {
                return 0.4;
              }
            }
          })
          .on("click", update_table)
          .on("mouseover", abrirTooltip)
          .on("mouseleave", cerrarTooltip)
          .on("mousemove", ajustarPosicionTooltip);
      },
      (update) => {
        update
          .transition()
          .attr("x", (d) => {
            if (d.nivel == 0) {
              return (
                Math.sin(d.angulo) * d.radio +
                ancho.value / 2 -
                radio_centro.value +
                4
              );
            } else {
              return (
                Math.sin(d.angulo) * (d.radio + radio_centro.value) +
                ancho.value / 2 -
                radio_nodo.value +
                4
              );
            }
          })
          .attr("y", (d) => {
            if (d.nivel == 0) {
              return (
                Math.cos(d.angulo) * d.radio +
                alto.value / 2 -
                radio_centro.value +
                4
              );
            } else {
              return (
                Math.cos(d.angulo) * (d.radio + radio_centro.value) +
                alto.value / 2 -
                radio_nodo.value +
                4
              );
            }
          })
          .attr("height", (d) => {
            if (d.nivel == 0) {
              return radio_centro.value * 2 - 8;
            } else {
              return radio_nodo.value * 2 - 8;
            }
          })
          .attr("width", (d) => {
            if (d.nivel == 0) {
              return radio_centro.value * 2 - 8;
            } else {
              return radio_nodo.value * 2 - 8;
            }
          })
          .attr("href", (d) => {
            let nuevo_nombre = d.nombre
              .toLowerCase()
              .replace("á", "a")
              .replace("é", "e")
              .replace("é", "e")
              .replace("í", "i")
              .replace("í", "i")
              .replace("ó", "o")
              .replace("ú", "u")
              .replace("ñ", "n");
            if (d.con_foto == "si") {
              return require(`../assets/img/${nuevo_nombre}.png`);
            } else {
              return require("../assets/img/sin foto.png");
            }
          })
          .attr("opacity", (d) => {
            if (nodo_seleccionado.value == "Ismael Zambada García") {
              return 1;
            } else {
              if (d.nombre == nodo_seleccionado.value) {
                return 1;
              } else {
                return 0.4;
              }
            }
          });
      },
      (exit) => {
        exit.remove();
      }
    );
}

function update_table() {
  let seleccion = d3.select(this).datum();
  nodo_seleccionado.value = seleccion.nombre;
}

function abrirTooltip() {
  tooltip_nodo.value.style("visibility", "visible").selectAll("text");

  let seleccion = d3.select(this).datum();
  nombre_tooltip.value = seleccion.nombre;
  alias_tooltip.value = seleccion.alias;
  vinculo_tooltip.value = seleccion.vinculo;
  anio_tooltip.value = seleccion.anio_ingreso_OFAC;
  permanece_tooltip.value = seleccion.permanece_OFAC;
}

function cerrarTooltip() {
  tooltip_nodo.value.style("visibility", "hidden");
}

function ajustarPosicionTooltip() {
  let position = d3.pointer(event, document.body);
  let width = window.innerWidth;

  if (width < 769) {
    // Si estamos en la vista movil
    if (position[0] < ancho.value / 2) {
      //Si estamos en la mitad izquierda del círuclo
      tooltip_nodo.value
        .style("left", position[0] + 20 + "px")
        .style("top", position[1] - 75 + "px");
    } else {
      //Si estamos en la mitad derecha
      tooltip_nodo.value
        .style("left", position[0] - 180 - 5 + "px")
        .style("top", position[1] - 75 + "px");
    }
  } else {
    // Si estamos en la vista web
    if (position[0] < ancho.value / 2) {
      //Si estamos en la mitad izquierda del círuclo
      tooltip_nodo.value
        .style("left", position[0] + 20 + "px")
        .style("top", position[1] - 30 + "px");
    } else {
      //Si estamos en la mitad derecha
      tooltip_nodo.value
        .style("left", position[0] - 300 - 5 + "px")
        .style("top", position[1] - 30 + "px");
    }
  }
}
</script>

<style scoped>
table {
  font-size: 12px;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid black;
  text-align: left;
  padding: 8px;
}
.contenedor-gral {
  display: flex;
  flex-wrap: wrap;
}

.contenedor-circulos {
  width: 65%;
  /*background-color: #f0ffce;*/
  align-content: center;
}

.contenedor-tabla {
  width: 34%;
  /*background-color: #f5f5f5;*/
  padding: 5px;
  align-content: center;
}
.tooltip-nodo-full {
  position: absolute;
  z-index: 2;
  background-color: #252323;
  color: white;
  opacity: 0.9;
  height: auto;
  width: 300px;
  font-size: 15px;
  padding: 3px;
}

.tooltip-nodo-movil {
  position: absolute;
  z-index: 2;
  background-color: #252323;
  color: white;
  opacity: 0.9;
  height: auto;
  width: 180px;
  font-size: 15px;
  padding: 3px;
}

.info_tooltip {
  /*background-color: green;*/
  margin: 3px;
}

.highlight {
  font-weight: bold;
}
@media (max-width: 769px) {
  .contenedor-circulos {
    width: 100%;
  }

  .contenedor-tabla {
    width: 100%;
  }
}
</style>
